module.exports = __webpack_public_path__ + "static/media/down-arrow.73423a6e.svg";